module.exports = "/assets/falcon.png";